import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "center_box" }

import { NTabPane, NTabs, NCard } from "naive-ui";
import Login from "@/pages/public/Login.vue";
import Register from "@/pages/public/Register.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NCard), null, {
      default: _withCtx(() => [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "logo_container" }, [
          _createElementVNode("img", {
            width: "30",
            height: "30",
            src: "/logo.svg",
            alt: "Винкод"
          }),
          _createElementVNode("span", { class: "logo_text" }, "Винкод")
        ], -1)),
        _createVNode(_unref(NTabs), {
          class: "card-tabs",
          "default-value": "signin",
          size: "large",
          type: "segment",
          style: {"margin":"0 -4px"},
          "pane-style": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NTabPane), {
              name: "signin",
              tab: "Вход"
            }, {
              default: _withCtx(() => [
                _createVNode(Login)
              ]),
              _: 1
            }),
            _createVNode(_unref(NTabPane), {
              name: "signup",
              tab: "Регистрация"
            }, {
              default: _withCtx(() => [
                _createVNode(Register)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})